module.exports = __webpack_public_path__ + "img/62.7da59dd0.jpg";